

<div class="container">
  <loader *ngIf="loading"></loader>
    <div *ngIf="!loading && assocTextOptions && assocTextOptions.length > 0">
    <div style="display: flex; flex-direction: row; gap: 5px; margin-bottom: 5px">
      <span>{{ "translate.manage-content.filterBy" | translate }}</span>
      <p-radioButton name="filter" value="not_associated_by_other" [(ngModel)]="filterValue"
        inputId="not_associated_by_other" (onClick)="onFilterChange()"></p-radioButton>
      <label for="not_associated_by_other">{{ "translate.claim-tool.not-associated-by-others" | translate }}</label>
      <p-radioButton name="filter" value="all" [(ngModel)]="filterValue" inputId="all"
        (onClick)="onFilterChange('all')"></p-radioButton>
      <label for="all">{{ "translate.claim-tool.doc-ref-options.all-filter" | translate }}</label>
  
    </div>
  </div>
  <ui-table
    *ngIf="!loading && displayAssocText && displayAssocText.length > 0"
    class="t-small"
    [isWrapped]="false"
    [data]="displayAssocText"
    [templates]="[
      {
        title: 'translate.general.text',
        template: phraseText
      },
      {
        title: 'translate.claim-tool.doc-assoc-text-options.modified-by-genai-column',
        template: modified_by_genai,
        permission: displayGenAi
      },
      {
        title: 'translate.general.actions',
        template: actions
      }
    ]"
  ></ui-table>
</div>

<ng-template #phraseText let-row="row">
  <!-- {{ row.phraseText }} -->
    {{ row.phrase_text }}
</ng-template>
<ng-template #modified_by_genai let-row="row">
  <!-- {{ row.phraseText }} -->
    <p>
      <i class="fa" [ngClass]="row.modified_by_genai ? 'fa-check':'fa-times'"></i>
    </p>
</ng-template>
<ng-template #actions let-row="row">
  <a *ngIf="canAddPhrase(row)" [class.disabled]="disabled" (click)="add(row)"
    >{{ "translate.general.add" | translate }}
  </a>
  <a *ngIf="canDeAssocPhrase(row)" [class.disabled]="disabled" (click)="add(row, true)"
    >{{ "tranlate.claim-tool.action.add-and-dissociate" | translate }}
  </a>
  <a *ngIf="canRemovePhrase(row)" class="c-warn" [class.disabled]="disabled" (click)="remove(row)"
    >{{ "translate.general.remove" | translate }}
  </a>
</ng-template>
